/* eslint-disable react/jsx-filename-extension */
import React from "react"

interface AddIconCollapseIconProps {
  className?: string
  width?: string
  height?: string
}

function AddIconCollapseIcon(props: Readonly<AddIconCollapseIconProps>) {
  const { className, width, height } = props
  const cssClassName = className ?? ""
  const cssWidth = width ?? "1em"
  const cssHeight = height ?? "1em"
  return (
    <span className="anticon anticon-collapse-add ">
      <svg
        className={cssClassName}
        xmlns="http://www.w3.org/2000/svg"
        width={cssWidth}
        height={cssHeight}
        fill="none"
        viewBox="0 0 20 20  "
      >
        <path
          d="M6.66602 10H13.3327"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 13.3337V6.66699"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49935 18.3337H12.4993C16.666 18.3337 18.3327 16.667 18.3327 12.5003V7.50033C18.3327 3.33366 16.666 1.66699 12.4993 1.66699H7.49935C3.33268 1.66699 1.66602 3.33366 1.66602 7.50033V12.5003C1.66602 16.667 3.33268 18.3337 7.49935 18.3337Z"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default AddIconCollapseIcon
